<template>
    <div id="novel_generator">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <generatorLeft @openContent="openContent" ></generatorLeft>
            <generatorHistroy v-if="histroyShow"></generatorHistroy>
            <generatorContent v-else></generatorContent>
            <generatorResult @openHistroy="openHistroy"></generatorResult>
        </div>
    </div>
</template>

<script>
import top from '../components/top.vue' //顶部
import generatorLeft from '../components/generator_left.vue' //左侧
import generatorContent from '../components/generator_content.vue' //创作信息
import generatorResult from '../components/generator_result.vue' //创作结果
import generatorHistroy from '../components/generator_histroy.vue' //创作历史记录
import { EventBus } from '@/utils/eventBus'
import api from '@/api/api';
export default {
    components: {
        top, generatorLeft, generatorContent, generatorResult, generatorHistroy
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
            histroyShow: false, //显示历史记录
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        openHistroy() {
            this.histroyShow = true
        },
        openContent(item, i) {
            this.histroyShow = false
            this.$nextTick(() => {
                EventBus.$emit('getTemplate', item)
            })
            sessionStorage.setItem('labelIndex', i);
        },
        openVip(){
             api.getUserinfo().then((res) => {
                if (res.code == 200) {
                    EventBus.$emit('openVip')
                } else {
                    EventBus.$emit('openLogin')
                }
            })
        }
    }
}
</script>

<style>
#novel_generator {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

#novel_generator .mian {
    width: 100%;
    padding-top: 20px;
}
</style>